import {
  CREATE_EMISSION_RECORD_ERROR,
  CREATE_EMISSION_RECORD_SUCCESS,
  DELETE_EMISSION_RECORD_ERROR,
  DELETE_EMISSION_RECORD_SUCCESS,
  UPDATE_EMISSION_RECORD_ERROR,
  UPDATE_EMISSION_RECORD_SUCCESS,
} from '@/containers/App/constants';
import { createAction } from '@reduxjs/toolkit';

export const updateEmissionRecordSuccessAction = createAction(UPDATE_EMISSION_RECORD_SUCCESS);
export const updateEmissionRecordErrorAction = createAction(UPDATE_EMISSION_RECORD_ERROR);

export const createEmissionRecordSuccessAction = createAction(CREATE_EMISSION_RECORD_SUCCESS);
export const createEmissionRecordErrorAction = createAction(CREATE_EMISSION_RECORD_ERROR);

export const deleteEmissionRecordSuccessAction = createAction(DELETE_EMISSION_RECORD_SUCCESS);
export const deleteEmissionRecordErrorAction = createAction(DELETE_EMISSION_RECORD_ERROR);
